import { NgModule } from '@angular/core';
import { SecondsToTimePipe } from './secondsToTime.pipe';

@NgModule({
  declarations: [SecondsToTimePipe],
  exports: [SecondsToTimePipe],
})
export class SecondsToTimePipeModule {}
